import React from 'react';
import { Container, Title, Text, Paper, Divider } from '@mantine/core';

const AllgemeineGeschaeftsbedingungen: React.FC = () => {
    return (
        <Container size="md" my="xl">
            <Title order={2} mb="lg">
                Allgemeine Geschäftsbedingungen
            </Title>
            <Text mb="xl">
                der MT Beteiligungsmanagement UG im Lizenzsystem LagerFirst für Produktverkäufe an Franchisenehmer
            </Text>

            {/* § 1 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 1 Allgemeines / Geltungsbereich
                </Title>
                <Text>
                    Es gelten ausschließlich diese Allgemeinen Liefer-, Leistungs- und Zahlungsbedingungen. Entgegenstehende oder von
                    unseren Bedingungen abweichende Bedingungen des Kunden erkennen wir nicht an. Unsere Allgemeinen Liefer-, Leistungs-
                    und Zahlungsbedingungen gelten auch dann, wenn wir in Kenntnis entgegenstehender oder von unseren Allgemeinen
                    Liefer-, Leistungs- und Zahlungsbedingungen abweichenden Bedingungen die Lieferung ausführen.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 2 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 2 Vertragsabschluss
                </Title>
                <Text mb="sm">
                    Unser Angebot ist freibleibend, sofern sich aus der Auftragsbestätigung nichts anderes ergibt oder wir nicht
                    ausdrücklich etwas anderes schriftlich erklärt haben.
                </Text>
                <Text mb="sm">
                    Ein Auftrag des Kunden wird durch unsere schriftliche Bestätigung oder durch Lieferung/Leistungserbringung angenommen.
                </Text>
                <Text>
                    An Abbildungen, Zeichnungen, Kalkulationen und sonstigen Unterlagen behalten wir uns Eigentums- und Urheberrechte vor,
                    sie dürfen Dritten nicht zugänglich gemacht werden. Vor ihrer Weitergabe an Dritte bedarf der Kunde unserer
                    ausdrücklichen schriftlichen Zustimmung.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 3 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 3 Preise/Zahlungsbedingungen
                </Title>
                <Text mb="sm">
                    Die im Intranet genannten Preise enthalten keine gesetzliche Umsatzsteuer. Die Möglichkeit zum Skontoabzug besteht
                    nicht.
                </Text>
                <Text mb="sm">
                    Sofern in unserer schriftlichen Auftragsbestätigung oder in sonstiger Weise schriftlich kein Zahlungsziel eingeräumt,
                    keine Teilzahlung oder Vorauskasse vereinbart worden ist, ist der Kaufpreis sofort nach Lieferung und Rechnungsstellung
                    zur Zahlung fällig.
                </Text>
                <Text mb="sm">
                    Aufrechnungsrechte stehen dem Kunden nur zu, wenn seine Gegenansprüche rechtskräftig festgestellt, unbestritten oder
                    von uns anerkannt sind.
                </Text>
                <Text mb="sm">
                    Schecks werden nicht angenommen. Lastschrift oder Überweisungen sind Standard-Zahlungsbedingungen.
                </Text>
                <Text mb="sm">
                    Bezahlungen mit Kreditkarte werden nur akzeptiert, wenn es vorher schriftlich von MT-Beteiligungsmanagement im
                    Lizenzsystem LagerFirst freigegeben wurde.
                </Text>
                <Text>
                    Werden uns nach Abschluss des Vertrages Umstände bekannt, nach denen von einer wesentlichen Vermögensverschlechterung des
                    Kunden auszugehen ist, so können wir nach unserer Wahl entweder Sicherheit binnen einer angemessenen Frist oder
                    Zahlung Zug um Zug gegen Auslieferung verlangen. Kommt der Kunde diesem Verlangen nicht nach, so sind wir vorbehaltlich
                    weiterer gesetzlicher Rechte berechtigt, nach Ablauf der gesetzten Frist vom Vertrag zurückzutreten. Sollte aus Gründen,
                    die vom Kunden zu vertreten sind, eine zweite oder weitere Anlieferung oder Anfahrt notwendig sein, so gehen die hierdurch
                    entstehenden Mehrkosten zu Lasten des Kunden.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 4 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 4 Lieferzeit / Abnahme
                </Title>
                <Text mb="sm">
                    Die Einhaltung unserer Leistungsverpflichtungen, insbesondere der angegebenen Lieferzeit, setzt die Einhaltung der
                    Verpflichtungen des Kunden (insbesondere die Leistung der Anzahlung) voraus.
                </Text>
                <Text mb="sm">
                    Lieferverzögerungen aufgrund höherer Gewalt oder aufgrund unvorhergesehener und nicht durch uns zu vertretender
                    Umstände wie Arbeitskampf, Rohstoffbeschaffungsschwierigkeiten und behördliche Anordnungen führen nicht zum
                    Verzug. Eine vereinbarte Lieferfrist verlängert sich um die Dauer der Behinderung.
                </Text>
                <Text mb="sm">
                    Dauert die Behinderung länger als zwei Monate, so sind wir und der Kunde nach Ablauf einer angemessenen
                    Nachfristsetzung berechtigt, hinsichtlich des noch nicht erfüllten Teils vom Vertrag zurückzutreten. Schadensersatzansprüche
                    sind in diesem Fall ausgeschlossen.
                </Text>
                <Text mb="sm">
                    Setzt uns der Kunde nach unserem Verzug eine angemessene Nachfrist, so ist er nach fruchtlosem Ablauf dieser Nachfrist
                    berechtigt, vom Vertrag zurückzutreten.
                </Text>
                <Text mb="sm">
                    Kommt der Kunde in Annahmeverzug oder verletzt er sonstige Mitwirkungspflichten, so sind wir berechtigt, entstandene
                    Mehraufwendungen zu verlangen. In diesem Fall geht auch die Gefahr eines zufälligen Untergangs oder einer zufälligen
                    Verschlechterung der Kaufsache in dem Zeitpunkt auf den Kunden über, in dem dieser in Annahmeverzug gerät. Im Falle
                    des Annahmeverzugs des Kunden haften wir nur für grobe Fahrlässigkeit und Vorsatz.
                </Text>
                <Text>
                    Wenn die Lieferzeit auf Wunsch des Kunden verlängert werden soll, sind wir berechtigt, ihm entstandene Mehrkosten zu
                    berechnen, soweit wir den Kunden hierauf vor Änderung der Lieferzeit hingewiesen haben. Verweigert der Käufer nach
                    Ablauf einer ihm gesetzten Nachfrist die Annahme oder erklärt er vorher ausdrücklich, nicht annehmen zu wollen, können
                    wir vom Vertrag zurücktreten und Schadenersatz wegen Nichterfüllung fordern. Als Schadenersatz wegen Nichterfüllung
                    können wir pauschal 25% des vereinbarten Kaufpreises für entstandene Kosten und entgangenen Gewinn verlangen. Dem Käufer
                    bleibt der Nachweis offen, dass ein Schaden überhaupt nicht entstanden ist oder der Schaden niedriger ist als die
                    Pauschale. Umgekehrt bleiben auch uns die Geltendmachung und der Nachweis eines die Pauschale übersteigenden Schadens
                    vorbehalten.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 5 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 5 Versand / Gefahrübergang
                </Title>
                <Text>
                    Der Versand erfolgt auf Verlangen des Kunden. Sofern sich aus der Auftragsbestätigung nichts anderes ergibt, geht die
                    Leistungsgefahr mit Übergabe der Ware an die mit der Auslieferung beauftragte Person über.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 6 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 6 Mängelgewährleistung
                </Title>
                <Text>
                    Gewichts-, Maß- und technische Angaben in unseren Katalogen sind, soweit nichts anderes ausdrücklich vereinbart wurde,
                    unverbindlich und sind insbesondere keine Beschaffenheitsgarantien (zugesicherte Eigenschaften). Ihre gesetzlichen
                    Gewährleistungsansprüche bleiben unberührt.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 7 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 7 Schadensersatz
                </Title>
                <Text mb="sm">
                    Unsere Haftung ist ausgeschlossen, sofern wir den Schaden nicht vorsätzlich, grob fahrlässig oder durch fahrlässige
                    Verletzung von Kardinalspflichten verursacht haben. Im Hinblick auf die fahrlässige Verletzung von Kardinalspflichten
                    ist unsere Haftung auf den vorhersehbaren und typischen Schaden begrenzt.
                </Text>
                <Text>
                    Entsprechendes gilt für die Haftung unserer Angestellten, Arbeitnehmer, Mitarbeiter und Erfüllungsgehilfen. Vorstehende
                    Haftungsausschlüsse – bzw. Beschränkungen gelten nicht für Ansprüche gemäß §§ 1, 4 Produkthaftungsgesetz, für die
                    Verletzung des Lebens oder bei Körper-/Gesundheitsschäden und wegen der Übernahme einer Garantie für das Vorhandensein
                    einer Beschaffenheit (Beschaffenheitsgarantie).
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 8 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 8 Eigentumsvorbehalt
                </Title>
                <Text mb="sm">
                    Wir behalten uns das Eigentum an den gelieferten Gegenständen bis zum Eingang aller Zahlungen aus dem Vertrag mit dem
                    Kunden vor. Soweit wir aufgrund eines Pflichtverstoßes des Kunden – ggf. nach Fristsetzung - zum Rücktritt berechtigt
                    sind, sind wir nach Rücknahme der gelieferten Sache zu deren Verwertung befugt. Der Verwertungserlös ist auf die
                    Verbindlichkeiten des Kunden abzüglich der erforderlichen und angefallenen Verwertungskosten anzurechnen.
                </Text>
                <Text>
                    Der Kunde ist berechtigt, den Liefergegenstand im ordentlichen Geschäftsgang weiter zu verkaufen; er tritt uns jedoch
                    bereits jetzt alle Forderungen (einschließlich USt) ab, die ihm aus der Weiterveräußerung gegen seine Abnehmer oder
                    gegen Dritte erwachsen – und zwar unabhängig davon, ob der Liefergegenstand ohne oder nach Verarbeitung weiterverkauft
                    worden ist. Zur Einziehung dieser Forderung ist der Kunde nach deren Abtretung ermächtigt. Unsere Befugnis, die
                    Forderung selbst einzuziehen, bleibt hiervon unberührt; jedoch verpflichten wir uns, die Forderung nicht einzuziehen,
                    solange der Kunde seinen Zahlungsverpflichtungen ordnungsgemäß nachkommt und nicht in Zahlungsverzug ist. Ist dies
                    jedoch der Fall, dann können wir verlangen, dass der Kunde uns die abgetretenen Forderungen und deren Schuldner bekannt
                    gibt, alle zum Einzug erforderlichen Angaben macht, die dazugehörigen Unterlagen aushändigt und den Schuldnern (Dritten)
                    die Abtretung mitteilt. Bei Pfändungen oder sonstigen Eingriffen Dritter hat uns der Kunde unverzüglich schriftlich zu
                    benachrichtigen und uns von den Kosten freizustellen, die erforderlich sind, um unser Eigentum – soweit dieses noch besteht –
                    zu sichern.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* § 9 */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    § 9 Schlussbestimmungen
                </Title>
                <Text mb="sm">
                    Die Rechtsbeziehungen zwischen den Parteien richten sich ausschließlich nach deutschem Recht unter Ausschluss des UN-Kaufrechts (CISG).
                </Text>
                <Text mb="sm">
                    Sollten einzelne Bestimmungen des Vertrages oder dieser Allgemeinen Bedingungen unwirksam oder undurchführbar sein oder werden, so wird dadurch die Wirksamkeit der anderen Bestimmungen nicht berührt. Statt der unwirksamen oder undurchführbaren Bestimmung gilt eine Regelung als vereinbart, die der unwirksamen oder undurchführbaren Bestimmung wirtschaftlich am nächsten kommt. Entsprechendes gilt für Vertragslücken.
                </Text>
                <Text mb="sm">
                    Ausschließlicher Gerichtsstand und Erfüllungsort ist Hamburg.
                </Text>
                <Text mb="sm">
                    Die Aufrechnung ist dem Kunden nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen gestattet.
                </Text>
                <Text>
                    Soweit gesetzlich zulässig steht dem Kunden kein Pfand-, Zurückbehaltungs- oder Leistungsverweigerungsrecht zu.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* DATENSCHUTZHINWEIS */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    DATENSCHUTZHINWEIS
                </Title>
                <Text mb="sm">
                    Bei allen Vorgängen der Datenverarbeitung (z.B. Erhebung, Verarbeitung und Übermittlung) verfahren wir nach den gesetzlichen
                    Vorschriften. Ihre für die Geschäftsabwicklung notwendigen Daten werden gespeichert und für die Bestellabwicklung im
                    erforderlichen Umfang an von uns beauftragte Dienstleister weitergegeben.
                </Text>
                <Text mb="sm">
                    Im Rahmen des gesetzlich Zulässigen und unter Berücksichtigung Ihrer jeweiligen schutzwürdigen Interessen an dem Ausschluss
                    der Übermittlung oder Nutzung können wir zur Bonitäts- und Kreditprüfung während der Dauer der Kundenbeziehung
                    Adress- und Bonitätsdaten an Dritte sowie ggf. an die SCHUFA 65203 Wiesbaden oder der Creditreform weitergeben.
                </Text>
                <Text mb="sm">
                    Ferner werden Adress- und Bestelldaten für eigene Marketingzwecke erhoben und verarbeitet. Für fremde Marketingzwecke werden
                    ausschließlich solche Daten weitergegeben, bei denen dies gesetzlich erlaubt ist (allgemein veröffentlichte und in Listen
                    zusammengefasste Daten gemäß § 28 Abs. 3 S.2 und S.4 Bundesdatenschutzgesetz).
                </Text>
                <Text>
                    Hinweis: Sie können der Nutzung, Verarbeitung und Übermittlung Ihrer personenbezogenen Daten zu Marketingzwecken jederzeit
                    durch eine formlose Mitteilung auf dem Postweg an MT Beteiligungsmanagement UG im Lizenzsystem LagerFirst, Am Glüsig 1c,
                    39365 Harbke, widersprechen. Dies gilt allerdings nicht für die zur Abwicklung Ihrer Bestellung erforderlichen Daten.
                </Text>
            </Paper>
            <Divider my="xl" />

            <Text size="sm">
                Stand: 01.02.2025
            </Text>
        </Container>
    );
};

export default AllgemeineGeschaeftsbedingungen;
